<script>
    export default {
        name: 'NormalSelect',
        props: {
            // 下拉框选项，格式为{value:'', text: ''}
            options: {
                default () {
                    return [];
                },
                required: false
            },
            // 选中值
            selected: {
                default: null,
                required: false
            },
            // 是否禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false,
            },
            // 提示文字
            placeholder: {
                type: String,
                default: '请选择',
                required: false,
            }
        },
        data () {
            return {
                selfSelected: this.selected
            };
        },
        watch: {
            selected (v) {
                this.selfSelected = v;
            }
        },
        computed: {
            compSelected: {
                get () {
                    // return this.selfSelected || (this.options[0] ? this.options[0].value : '');
                    return this.$util.validate.isEmpty(this.selfSelected) ? 'placeholder' : this.selfSelected;
                },
                set (val) {
                    this.selfSelected = val;
                    this.$emit('change', val);
                }
            },
            compCls () {
                return {
                    'normal-select__disabled': this.disabled,
                };
            }
        },
        model: {
            prop: 'selected',
            event: 'change'
        }
    };
</script>
<template>
    <div class="normal-select-box" :class="compCls">
        <select class="normal-select"
                :disabled="disabled"
                :class="{placeholder: compSelected === 'placeholder'}"
                v-model="compSelected"
                ref="select">
            <option value="placeholder" disabled selected>{{placeholder}}</option>
            <option v-for="item in options"
                    :key="item.value"
                    :value="item.value">{{item.text}}
            </option>
        </select>
    </div>
</template>
<style scoped lang="less">
    @import "../../assets/less/widgets-var";

    .normal-select-box {
        position: relative;

        &.normal-select__disabled {
            background-color: @otherDisabledBgClr;

            &:after {
                background-color: @otherDisabledBgClr;
            }
        }

        .placeholder-box {
            position: absolute;
            z-index: 99;
            left: 0;
            top: 0;
            .px2rem(right, 60);
            .px2rem(padding-left, 30);
            .px2rem(padding-right, 60);
            .px2rem(height, 90);
            .px2rem(line-height, 90);
            color: #757575;
            background: @whiteBg;
        }

        &:after {
            font-family: cmsicon;
            content: "\e697";
            display: inline-block;
            border-color: @otherIptSelTipsDisbaledClr;
            position: absolute;
            color: @otherIptSelTipsDisbaledClr;
            .px2rem(height, 75);
            .px2rem(line-height, 75);
            .px2rem(width, 60);
            text-align: center;
            top: 50%;
            .px2rem(margin-top, -37.5);
            right: 0;
            background-color: #fff;
            z-index: 9;
        }
    }

    .normal-select {
        border: 0;
        outline: 0;
        background-color: transparent;
        width: 100%;
        font-size: inherit;
        .px2rem(height, 90);
        .px2rem(line-height, 90);
        position: relative;
        z-index: 1;
        .px2rem(padding-left, 30);
        .px2rem(padding-right, 60);

        &.placeholder {
            color: #797979;
        }
    }
</style>
